import ApiServiceBiometrics from "../../../api/service/apiServiceBiometrics";
const querystring = require('querystring');

var BiometricService = {

    getBiometricList: function($data){
        return new Promise(function(resolve, reject){
            let $options = {};
            $options.url = "biometriclist"
            $options.method = "get"

            if($data){
                $options.url = "biometriclist?" + querystring.stringify($data) 
                console.log($options.url)
            }
            ApiServiceBiometrics.request($options)
                .then(response => {
                    console.log('test');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
        });
    },

    fileUpload: function($data){
        return new Promise(function(resolve, reject){
            let $options = {};
            $options.url = "insData"
            $options.method = "get"

            if($data){
                $options.url = "insData?" + querystring.stringify($data) 
                console.log($options.url)
            }
            ApiServiceBiometrics.request($options)
                .then(response => {
                    console.log('test');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
        });
    }
};

export default BiometricService